export enum USER_SETTINGS {
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453266
     */
    MY_SETTINGS = 'MY_SETTINGS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453799
     */
    MAIN_LANGUAGE = 'USER_PROFILE_MAIN_LANGUAGE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453796
     */
    ALTERNATIVE_LANGUAGE = 'USER_PROFILE_FALLBACK_LANGUAGE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453797
     */
    HISTORY_VISIBLE = 'USER_PROFILE_HISTORY_VISIBLE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453798
     */
    HISTORY_VISIBLE_HELP = 'USER_PROFILE_HISTORY_VISIBLE_HELP',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453787
     */
    ALTERNATE_EMAIL = 'USER_PROFILE_ALTERNATE_EMAIL',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453788
     */
    CURRENT_PASSWORD = 'USER_PROFILE_CURRENT_PASSWORD',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453804
     */
    PASSWORD = 'USER_PROFILE_PASSWORD',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453806
     */
    REPASSWORD = 'USER_PROFILE_REPASSWORD',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453805
     */
    PASSWORD_DO_NOT_MATCH = 'USER_PROFILE_PASSWORD_DO_NOT_MATCH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077941
     */
    ENABLE_PUSH_LABEL = 'NOTIFICATION.PREFERENCES.ENABLE.PUSH.LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077942
     */
    ENABLE_PUSH_DESCRIPTION = 'NOTIFICATION.PREFERENCES.ENABLE.PUSH.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077951
     */
    FREQUENCY = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077955
     */
    FREQUENCY_IMMEDIATE_LABEL = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.IMMEDIATE.LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68077964
     */
    FREQUENCY_IMMEDIATE_DESCRIPTION = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.IMMEDIATE.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078053
     */
    FREQUENCY_DAILY_SUMMARY_LABEL = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.DAILY_SUMMARY.LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078060
     */
    FREQUENCY_DAILY_SUMMARY_DESCRIPTION = 'NOTIFICATION.PREFERENCES.EMAIL.FREQUENCY.DAILY_SUMMARY.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=27149299
     */
    SOCIAL_PROFILES = 'SOCIAL_PROFILES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=41841405
     */
    NATIVE_INTEGRATIONS = 'NATIVE_INTEGRATIONS',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078077
     */
    DO_NOT_DISTURB_HEADER = 'NOTIFICATION.PREFERENCES.DO_NOT_DISTURB.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078811
     */
    DO_NOT_DISTURB_LABEL = 'NOTIFICATION.PREFERENCES.DO_NOT_DISTURB.LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078820
     */
    NOTIFICATION_PREFERENCES_TABLE_HEADER = 'NOTIFICATION.PREFERENCES.TABLE.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078850
     */
    BELL_COLUMN_HEADER = 'NOTIFICATION.PREFERENCES.TABLE.BELL.COLUMN.HEADER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68078825
     */
    CHECK_ALL_ROW_LABEL = 'NOTIFICATION.PREFERENCES.TABLE.CHECK_ALL.ROW.LABEL',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453808
     */
    USER_PROFILE_SAVE_SUCCESS = 'USER_PROFILE_SAVE_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=337316449
     */
    SETTINGS_SUBTITLE = 'USER_SETTINGS.SUBTITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=342804650
     */
    INTEGRATIONS_EMPTY_STATE = 'USER_SETTINGS.INTEGRATIONS_EMPTY_STATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=342804656
     */
    INTEGRATIONS_EMPTY_DESCRIPTION = 'USER_SETTINGS.INTEGRATIONS_EMPTY_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=434744003
     */
    UNSUBSCRIBE = 'USER_SETTINGS.UNSUBSCRIBE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=55428375
     */
    UNSUBSCRIBE_FROM_EMAIL = 'USER_SETTINGS.UNSUBSCRIBE_FROM_EMAIL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=434743766
     */
    UNSUBSCRIBE_MESSAGE_PART1 = 'USER_SETTINGS.UNSUBSCRIBE_MESSAGE_PART1',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=434746277
     */
    UNSUBSCRIBE_MESSAGE_PART2 = 'USER_SETTINGS.UNSUBSCRIBE_MESSAGE_PART2',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628466639
     */
    APP_LOGIN_CODE = 'USER_SETTINGS.APP_LOGIN_CODE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628471897
     */
    APP_LOGIN_SCAN_QR_CODE = 'USER_SETTINGS.APP_LOGIN_SCAN_QR_CODE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628471959
     */
    APP_LOGIN_GENERATE_QR_CODE = 'USER_SETTINGS.APP_LOGIN_GENERATE_QR_CODE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628471981
     */
    QR_CODE_WARNING = 'USER_SETTINGS.QR_CODE_WARNING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628471998
     */
    QR_CODE_EXPIRES = 'USER_SETTINGS.QR_CODE_EXPIRES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=628565610
     */
    QR_CODE = 'USER_SETTINGS.QR_CODE',
}

/**
 * List of all the keys used to display the notification type description.
 * */
export enum NOTIFICATION_TYPE_DESC_KEYS {
    ARTICLE_MENTION = 'NOTIFICATION.TYPE.ARTICLE.MENTION.DESCRIPTION',
    ARTICLE_NEW = 'NOTIFICATION.TYPE.ARTICLE.NEW.DESCRIPTION',
    COMMENT_LIKE = 'NOTIFICATION.TYPE.COMMENT.LIKE.DESCRIPTION',
    COMMENT_MENTION = 'NOTIFICATION.TYPE.COMMENT.MENTION.DESCRIPTION',
    COMMENT_MENTION_ON_ARTICLE = 'NOTIFICATION.TYPE.COMMENT.MENTION.ON.ARTICLE.DESCRIPTION',
    COMMENT_MENTION_ON_EVENT = 'NOTIFICATION.TYPE.COMMENT.MENTION.ON.EVENT.DESCRIPTION',
    COMMENT_NEW = 'NOTIFICATION.TYPE.COMMENT.NEW.DESCRIPTION',
    COMMENT_REPLY = 'NOTIFICATION.TYPE.COMMENT.REPLY.DESCRIPTION',
    COMMENT_REPORT_ACCEPTED = 'NOTIFICATION.TYPE.COMMENT.REPORT.ACCEPTED.DESCRIPTION',
    COMMENT_REPORT_CREATED = 'NOTIFICATION.TYPE.COMMENT.REPORT.CREATED.DESCRIPTION',
    COMMENT_REPORT_REVIEWED = 'NOTIFICATION.TYPE.COMMENT.REPORT.REVIEWED.DESCRIPTION',
    COMMUNITY_EXTENDED_SERVICE_MANAGEMENT = 'NOTIFICATION.TYPE.COMMUNITY.EXTENDED.SERVICE.MANAGEMENT.DESCRIPTION',
    COMMUNITY_NEW_ACCESS_REQUEST = 'NOTIFICATION.TYPE.COMMUNITY.NEW.ACCESS.REQUEST.DESCRIPTION',
    COMMUNITY_NEW_CREDENTIAL = 'NOTIFICATION.TYPE.COMMUNITY.NEW.CREDENTIAL.DESCRIPTION',
    CONTENT_EXPIRATION = 'NOTIFICATION.TYPE.CONTENT.EXPIRATION.DESCRIPTION',
    CONTENT_LIKE = 'NOTIFICATION.TYPE.CONTENT.LIKE.DESCRIPTION',
    CONTENT_NEW = 'NOTIFICATION.TYPE.CONTENT.NEW.DESCRIPTION',
    CONTENT_MENTION = 'NOTIFICATION.TYPE.CONTENT.MENTION.DESCRIPTION',
    CONTENT_REFUSED = 'NOTIFICATION.TYPE.CONTENT.REFUSED.DESCRIPTION',
    CONTENT_REPORT_ACCEPTED = 'NOTIFICATION.TYPE.CONTENT.REPORT.ACCEPTED.DESCRIPTION',
    CONTENT_REPORT_CREATED = 'NOTIFICATION.TYPE.CONTENT.REPORT.CREATED.DESCRIPTION',
    CONTENT_REPORT_REVIEWED = 'NOTIFICATION.TYPE.CONTENT.REPORT.REVIEWED.DESCRIPTION',
    CONTENT_UPDATE = 'NOTIFICATION.TYPE.CONTENT.UPDATE.DESCRIPTION',
    CONTENT_VALIDATED = 'NOTIFICATION.TYPE.CONTENT.VALIDATED.DESCRIPTION',
    CONTENT_WORKFLOW = 'NOTIFICATION.TYPE.CONTENT.WORKFLOW.DESCRIPTION',
    CUSTOM = 'NOTIFICATION.TYPE.CUSTOM.DESCRIPTION',
    EVENT_INVITATION_CREATED = 'NOTIFICATION.TYPE.EVENT.INVITATION.CREATED.DESCRIPTION',
    EVENT_MENTION = 'NOTIFICATION.TYPE.EVENT.MENTION.DESCRIPTION',
    EVENT_NEW = 'NOTIFICATION.TYPE.EVENT.NEW.DESCRIPTION',
    EVENT_REGISTRATION_REQUEST = 'NOTIFICATION.TYPE.EVENT.REGISTRATION.REQUEST.DESCRIPTION',
    EVENT_REGISTRATION_RESPONSE = 'NOTIFICATION.TYPE.EVENT.REGISTRATION.RESPONSE.DESCRIPTION',
    EVENT_UPDATED = 'NOTIFICATION.TYPE.EVENT.UPDATED.DESCRIPTION',
    EVENT_DELETED = 'EVENTS.DELETED',
    LEARNING_CONGRATULATION = 'NOTIFICATION.TYPE.LEARNING.CONGRATULATION.DESCRIPTION',
    LEARNING_COURSE_BEGINNING = 'NOTIFICATION.TYPE.LEARNING.COURSE.BEGINNING.DESCRIPTION',
    LEARNING_COURSE_ENDING_SOON = 'NOTIFICATION.TYPE.LEARNING.COURSE.ENDING.SOON.DESCRIPTION',
    LEARNING_COURSE_ENDING_TODAY = 'NOTIFICATION.TYPE.LEARNING.COURSE.ENDING.TODAY.DESCRIPTION',
    LEARNING_DUEL = 'NOTIFICATION.TYPE.LEARNING.DUEL.DESCRIPTION',
    LEARNING_REMINDER = 'NOTIFICATION.TYPE.LEARNING.REMINDER.DESCRIPTION',
    POST_MENTION = 'NOTIFICATION.TYPE.POST.MENTION.DESCRIPTION',
    POST_NEW = 'NOTIFICATION.TYPE.POST.NEW.DESCRIPTION',
    POST_REPORT_ACCEPTED = 'NOTIFICATION.TYPE.POST.REPORT.ACCEPTED.DESCRIPTION',
    POST_REPORT_CREATED = 'NOTIFICATION.TYPE.POST.REPORT.CREATED.DESCRIPTION',
    POST_REPORT_REVIEWED = 'NOTIFICATION.TYPE.POST.REPORT.REVIEWED.DESCRIPTION',
    POST_STATUS_UPDATE = 'NOTIFICATION.TYPE.POST.STATUS.UPDATE.DESCRIPTION',
    POST_UPDATE = 'NOTIFICATION.TYPE.POST.UPDATE.DESCRIPTION',
    REPLY_LIKE = 'NOTIFICATION.TYPE.REPLY.LIKE.DESCRIPTION',
    SOCIAL_ADVOCACY_NEW_SHAREABLE_CONTENT = 'NOTIFICATION.TYPE.SOCIAL.ADVOCACY.NEW.SHAREABLE.CONTENT.DESCRIPTION',
}

/** Override like kinds key's with reaction when the feature flag is enabled. */
export enum NOTIFICATION_TYPE_DESC_KEYS_WITH_REACTIONS {
    REPLY_LIKE = 'NOTIFICATION.TYPE.REPLY.REACTION.DESCRIPTION',
    CONTENT_LIKE = 'NOTIFICATION.TYPE.CONTENT.REACTION.DESCRIPTION',
    COMMENT_LIKE = 'NOTIFICATION.TYPE.COMMENT.REACTION.DESCRIPTION',
}

export const getNotificationLabelByKind = (kind: string) => `NOTIFICATION.TYPE.${kind.replace(/_/g, '.')}.DESCRIPTION`;
